export const DEVICES_FETCHED = 'DEVICES_FETCHED';
